<template>
    <div class="resource">
        <div>
            <p>
                <i class="el-icon-loading loading"></i>
            </p>
            <p class="hit">资源访问出错, 正在加急修复中!</p>
            <p>剩余<span class="hit">{{time}}</span>秒，进行重试资源</p>
            <p class="hit">*可能会重试几次，请耐心等待*</p>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                time: 30
            }
        },
        created() {
            if (this.isPureDigitStr(this.$route.query.code)) {
                this.$http.getrepair(this.$route.query.code).then(response=>{}).catch(err=>{})
            } else {
                location.href = `/repair?code=${localStorage.getItem("rescode")}`;
            }
            this.count_down()
        },
        methods:{
            isPureDigitStr(str){
                return /^\d+$/.test(str);
            },
            count_down () {
                setTimeout(()=>{
                    if (!this.time) {
                        location.href = `/resource?code=${this.$route.query.code}`
                    }else{
                        this.time -= 1
                        this.count_down()
                    }
                }, 1000)
            }
        }
    }
</script>
<style scoped>
    .resource {
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        margin-top: 100px;
    }

    .resource p {
        margin-top: 20px;
    }

    .loading {
        font-size: 40px;
    }

    .load {
        display: inline-block;
        width: 20px;
        text-align: left;
    }

    .occupied {
        padding: 0 20px;
    }
    .hit {
        color: red;
        padding: 0 5px;
    }
</style>